// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const constants = {
    button: {
        rounded: 3,
    },
    header: {
        size: {
            default: 65,
            sticky: 70,
            mobile: 150,
            top: 40, // from secondaryMenu

            nav: 50,
            gsm: {
                default: 50,
                mobile: 70,
            },
        },
        secondaryMenu: {
            height: 40,
        },
        notification: {
            height: 46,
        },
    },
    cookies: {
        globalMessages: "globalMessages",
        hiddenNotificationHeader: "hiddenNotificationHeader",
    },
    localStorage: {
        shouldLoadProductsForProductListPage: "shouldLoadProductsForProductListPage",
    },
    customEvents: {
        loadingOverlay: "XngLoadingOverlayEvent",
        forceShowHeaderPopupOverlay: "forceShowHeaderPopupOverlayEvent",
        footerFeatureBrands: "footerFeatureBrands",
        mainNavigation: {
            key: "mainNavigation_events",
            types: {
                hideMenu: "mainNavigation_hideMenu",
            },
        },
        updatePoNumberAndJobField: {
            key: "checkout_updatePoNumberAndJobField_events",
            types: {
                poNumber: "poNumber",
                job: "job",
            },
        },
    },
};
